/**
 * True when the authenticated principal carries the "Admin" role. The role claim
 * may arrive as a single string ("User") or, for admins, as an array of roles
 * (["User", "Admin"]) when the token carries more than one role claim.
 */
export const roleContainsAdmin = (role: unknown): boolean => {
  if (Array.isArray(role)) {
    return role.includes("Admin");
  }
  return role === "Admin";
};
